export default __webpack_public_path__ + "static/media/PMINGLIU.00f34c1d.ttf";